import React, { Component } from "react";

import { getUserId } from "../helper/user_helper";

import UserProfile from "../components/profile/user_profile";
import Loader from "../components/loader";

class UserProfilePage extends Component {
  state = {
    username: null,
    loaded: false,
    user: null,
    errors: ""
  };

  constructor(props) {
    super(props);
    this.state = {
      username: props.match.params.id,
      loaded: false,
      user: null,
      errors: ""
    };
  }
  componentDidMount() {
    this.getUser();
  }

  componentWillUnmount() {
    if (this.getUserCall) {
      this.getUserCall.cancel();
    }
  }

  componentDidUpdate() {
    if (this.props.match.params.id !== this.state.username) {
      this.setState({
        loaded: false,
        username: this.props.match.params.id
      });
      this.getUser();
    }
  }

  render() {
    if (!this.state.loaded) {
      return <Loader loaded={this.state.loaded} />;
    }
    return (
      <UserProfile
        username={this.state.username}
        user={this.state.user}
        me={false}
        loaded={this.state.loaded}
        handleAddFriend={this.handleAddFriend}
        handleRemoveFriend={this.handleRemoveFriend}
        errors={this.state.errors}
      />
    );
  }

  getUser() {
    const self = this;
    this.getUserCall = getUserId(this.props.match.params.id);
    this.getUserCall.promise.then(answer => {
      self.setState({
        user: answer.user,
        loaded: true,
        errors: answer.errors
      });
    });
  }

  handleAddFriend = (errors, username, friendship_type) => {
    if (errors !== "") {
      this.setState({ errors });
    } else {
      var user = this.state.user;
      user.friend = true;
      user.friendship_type = friendship_type;
      user.total_followers += 1;
      this.setState({ user });
    }
  };

  handleRemoveFriend = errors => {
    if (errors !== "") {
      this.setState({ errors });
    } else {
      var user = this.state.user;
      user.friend = false;
      user.total_followers -= 1;
      this.setState({ user });
    }
  };
}

export default UserProfilePage;



// WEBPACK FOOTER //
// ./src/pages/user_profile.jsx